export default "__VITE_ASSET__4fa9b525__"